// extracted by mini-css-extract-plugin
export const sectionWhyChooseUs = "whyChooseUs-module--sectionWhyChooseUs--1pnRj";
export const sectionContainer = "whyChooseUs-module--sectionContainer--CbZi9";
export const sectionBottomBackground = "whyChooseUs-module--sectionBottomBackground--3HiTK";
export const listWrapper = "whyChooseUs-module--listWrapper--3z4vt";
export const wcuItem = "whyChooseUs-module--wcuItem--3-lJQ";
export const wcuHeading = "whyChooseUs-module--wcuHeading--HEylp";
export const wcuContent = "whyChooseUs-module--wcuContent--1_58_";